import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

import { ViewInvoiceModal } from './Modal_ViewInvoice';

import '../../css/layout.css';


export function Modal_Onboarding_Address (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_Zasava_Context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewBusinessAddressDetails, setViewBusinessAddressDetails] = useState([]);

    let [addressNumber, setAddressNumber] = useState(null);
    let [streetName, setStreetName] = useState(null);
    let [city, setCity] = useState(null);
    let [cityDistrict, setCityDistrict] = useState(null);
    let [digitalAddress, setDigitalAddress] = useState(null);
    let [country, setCountry] = useState(null);
    let [countryRegion, setCountryRegion] = useState(null);


    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);


    let selectedFileRef = useRef();


    function getData_businessAddress () {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: "74503_view_businessAddress_data",
                user: acctID,
                schemaName: schema,
                xMerchantAccountID: props.data.merchantID,
                xMerchantSchema: props.data.merchantSchema,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');


                setAddressNumber(cols[0]);
                setStreetName(cols[1]);
                setCity(cols[2]);
                setCityDistrict(cols[3]);
                setDigitalAddress(cols[4]);
                setCountryRegion(cols[5]);
                setCountry(cols[6]);


                setViewBusinessAddressDetails((prevViewBusinessAddress) => {
                    return prevViewBusinessAddress.concat({
                        addressNumber: cols[0], 
                        streetName: cols[1], 
                        city: cols[2], 
                        cityDistrict: cols[3], 
                        digitalAddress: cols[4], 
                        countryRegion: cols[5], 
                        country: cols[6], 

                    })
                });
            } 
        })

    };
    

    function handle_change(event)
    {

        //alert("in Handle change 1");
        //alert(event);
        //alert(event[0]);
        //alert(event[1]);

        if(event[0] == 'row_1')
        {

            setCountry(event[1]);
            setRow_1(false);
        }
        
        if(event[0] == 'row_2')
        {

            setCountryRegion(event[1]);
            setRow_2(false);
        }
        
    }



    function updateAddress() {

        
        props.updateAddress([addressNumber, streetName, city, cityDistrict, digitalAddress, country, countryRegion]);
        props.closeModal();
    }

    useEffect(() => {

        getData_businessAddress();

    }, [])  
    

    //alert("In Update Aplicant");
    //alert(interview_status);
    
    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonContent className='grid_content'>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <h1>Business Address</h1>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>Country</IonText>
                        </IonCol>
                        <IonCol>
                            {row_1 == false && <IonText>{country}</IonText>}
                        </IonCol>
                        {row_1 == false && <IonCol>
                            <IonButton onClick={() => setRow_1(true)}>Update</IonButton>
                        </IonCol>}
                        {row_1 == true && <IonCol>
                            <select name="interview_status" id='interview_status' defaultValue={country} onChange={(e) => handle_change(['row_1', e.target.value])}>
                                <option value='none'>Select</option>
                                <option value='Ghana'>Ghana</option>
                            </select>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>Country Region</IonText>
                        </IonCol>
                        <IonCol>
                            {row_2 == false && <IonText>{countryRegion}</IonText>}
                        </IonCol>
                        {row_2 == false && <IonCol>
                            <IonButton onClick={() => setRow_2(true)}>Update</IonButton>
                        </IonCol>}
                        {row_2 == true && <IonCol>
                            <select name="interview_status" id='interview_status' defaultValue={countryRegion} onChange={(e) => handle_change(['row_2', e.target.value])}>
                                <option value='none'>Select</option>
                                <option value='central'>Central</option>
                                <option value='eastern'>Eastern</option>
                                <option value='western'>Western</option>
                                <option value='northern'>Northern</option>
                            </select>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>Address Number</IonText>
                        </IonCol>
                        <IonCol>
                            {row_3 == true && <IonInput type='text' placeholder='Enter House Number' onIonChange={(e) => setAddressNumber(e.detail.value)}></IonInput>}
                            {row_3 == false && <IonText>{addressNumber}</IonText>}
                        </IonCol>
                        {row_3 == false && <IonCol>
                            <IonButton onClick={() => setRow_3(true)}>Update</IonButton>
                        </IonCol>}
                        {row_3 == true && <IonCol>
                            <IonButton onClick={() => setRow_3(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>Street Name</IonText>
                        </IonCol>
                        <IonCol>
                            {row_4 == true && <IonInput type='text' placeholder='Enter Street Name' onIonChange={(e) => setStreetName(e.detail.value)}></IonInput>}
                            {row_4== false && <IonText>{streetName}</IonText>}
                        </IonCol>
                        {row_4 == false && <IonCol>
                            <IonButton onClick={() => setRow_4(true)}>Update</IonButton>
                        </IonCol>}
                        {row_4 == true && <IonCol>
                            <IonButton onClick={() => setRow_4(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>City</IonText>
                        </IonCol>
                        <IonCol>
                            {row_5 == true && <IonInput type='text' placeholder='Enter City' onIonChange={(e) => setCity(e.detail.value)}></IonInput>}
                            {row_5 == false && <IonText>{city}</IonText>}
                        </IonCol>
                        {row_5 == false && <IonCol>
                            <IonButton onClick={() => setRow_5(true)}>Update</IonButton>
                        </IonCol>}
                        {row_5 == true && <IonCol>
                            <IonButton onClick={() => setRow_5(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>City District</IonText>
                        </IonCol>
                        <IonCol>
                            {row_6 == true && <IonInput type='text' placeholder='Enter City District' onIonChange={(e) => setCityDistrict(e.detail.value)}></IonInput>}
                            {row_6 == false && <IonText>{cityDistrict}</IonText>}
                        </IonCol>
                        {row_6 == false && <IonCol>
                            <IonButton onClick={() => setRow_6(true)}>Update</IonButton>
                        </IonCol>}
                        {row_6 == true && <IonCol>
                            <IonButton onClick={() => setRow_6(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>Digital Address</IonText>
                        </IonCol>
                        <IonCol>
                            {row_7 == true && <IonInput type='text' placeholder='Enter Ditital Address' onIonChange={(e) => setDigitalAddress(e.detail.value)}></IonInput>}
                            {row_7 == false && <IonText>{digitalAddress}</IonText>}
                        </IonCol>
                        {row_7 == false && <IonCol>
                            <IonButton onClick={() => setRow_7(true)}>Update</IonButton>
                        </IonCol>}
                        {row_7 == true && <IonCol>
                            <IonButton onClick={() => setRow_7(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonButton  onClick={() => updateAddress()}>Confirm Update</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonContent>

        <IonFooter className='appFooter_internal'>
            <IonButton onClick={() => props.closeModal()}>Cancel </IonButton>
        </IonFooter>


        </IonModal>) : null}
    </React.Fragment>
    )
}